import { render } from "./payment-hdp-creditcard.vue?vue&type=template&id=31afcd2e"
import script from "./payment-hdp-creditcard.vue?vue&type=script&lang=js"
export * from "./payment-hdp-creditcard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__